import { IFaireMoney } from '@faire/web-api--source/indigofair/data/IFaireMoney';

export namespace IInstrumentLimitContext {
  export enum Surface {
    SURFACE_UNKNOWN = 'SURFACE_UNKNOWN',
    CHECKOUT = 'CHECKOUT',
    INVOICE = 'INVOICE',
    ACCOUNT_SETTINGS = 'ACCOUNT_SETTINGS',
    INSIDER = 'INSIDER',
    PAYMENT_PLAN = 'PAYMENT_PLAN',
    FAIRE_PAY = 'FAIRE_PAY',
  }

  /**
   * Return an instance of IInstrumentLimitContext with the provided fields. Any field not
   * listed will be populated with an empty value (an empty array,
   * or undefined, whichever is valid for the type of the value.)
   */
  export const build = (
    partial?: Partial<IInstrumentLimitContext>
  ): IInstrumentLimitContext =>
    ({
      ...(partial ?? {}),
    }) as IInstrumentLimitContext;
}

export interface IInstrumentLimitContext {
  surface: keyof typeof IInstrumentLimitContext.Surface | undefined;
  /**
   * Context-specific parameter, the amount being checkout out or the order amount being paid.
   */
  amount: IFaireMoney | undefined;
}
